<template>
  <el-card
    class="absolute model-edit-tool w-468px text-white p-10px"
    :style="{
      height: location.height,
      top: location.top,
      right: location.float === 'right' ? '25px' : '',
      left: location.float === 'left' ? '25px' : '',
    }"
  >
    <div slot="header" class="flex justify-between">
      <span class="text-14px">模型编辑</span>
      <span
        class="iconfont icon-line-close float-right cursor-pointer text-12px"
        @click="closeComponent"
      ></span>
    </div>
    <div class="tool-content h-full text-12px p-10px mt-10px">
      <el-row :gutter="10" type="flex" align="middle">
        <el-col :span="4">对象编码</el-col>
        <el-col :span="20"
          ><el-input v-model="currentTagCode" placeholder="对象编码" size="small"></el-input
        ></el-col>
      </el-row>
      <el-row :gutter="10" type="flex" align="middle" class="mt-10px">
        <el-col :span="4">模型工具</el-col>
        <el-col :span="20">
          <el-tooltip effect="dark" content="移动" placement="top">
            <i
              class="iconfont icon-yxr-move text-20px mr-20px cursor-pointer"
              :class="{ 'text-blue-500': editType === 1 }"
              @click="setEditType(1)"
            ></i>
          </el-tooltip>
          <el-tooltip effect="dark" content="旋转" placement="top">
            <i
              class="iconfont icon-yxr-rotate text-20px mr-20px cursor-pointer"
              :class="{ 'text-blue-500': editType === 2 }"
              @click="setEditType(2)"
            ></i>
          </el-tooltip>
          <el-tooltip effect="dark" content="缩放" placement="top">
            <i
              class="iconfont icon-line-fullScreen text-20px mr-20px cursor-pointer"
              :class="{ 'text-blue-500': editType === 3 }"
              @click="setEditType(3)"
            ></i>
          </el-tooltip>
          <el-tooltip effect="dark" content="阵列" placement="top">
            <i
              class="iconfont icon-bg-application text-20px cursor-pointer"
              @click="toCloneNode"
            ></i>
          </el-tooltip>
        </el-col>
      </el-row>
      <el-row :gutter="10" type="flex" align="middle" class="mt-10px">
        <el-col :span="2">位置</el-col>
        <el-col :span="1"><span>X</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localTranslation[0]"
            size="mini"
            class="w-full"
            @change="changeLocalTranslation"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>Y</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localTranslation[1]"
            size="mini"
            class="w-full"
            @change="changeLocalTranslation"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>Z</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localTranslation[2]"
            size="mini"
            class="w-full"
            @change="changeLocalTranslation"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>m</span></el-col>
      </el-row>
      <el-row :gutter="10" type="flex" align="middle" class="mt-10px">
        <el-col :span="2">旋转</el-col>
        <el-col :span="1"><span>X</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localRotation[0]"
            size="mini"
            class="w-full"
            @change="changeLocalRotation"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>Y</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localRotation[1]"
            size="mini"
            class="w-full"
            @change="changeLocalRotation"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>Z</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localRotation[2]"
            size="mini"
            class="w-full"
            @change="changeLocalRotation"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>°</span></el-col>
      </el-row>
      <el-row :gutter="10" type="flex" align="middle" class="mt-10px">
        <el-col :span="2">比例</el-col>
        <el-col :span="1"><span>X</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localScaling[0]"
            size="mini"
            class="w-full"
            @change="changeLocalScaling"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>Y</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localScaling[1]"
            size="mini"
            class="w-full"
            @change="changeLocalScaling"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>Z</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localScaling[2]"
            size="mini"
            class="w-full"
            @change="changeLocalScaling"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>%</span></el-col>
      </el-row>
    </div>
    <div class="card-footer mt-10px bottom-0 right-10px">
      <el-row class="w-full">
        <el-col :span="18">
          <el-button
            class="iconfont icon-app-update"
            size="mini"
            :disabled="resetDisable"
            @click="resetCommand"
            >重置</el-button
          >
          <el-button
            size="mini"
            class="iconfont icon-pc-back"
            @click="undoCommand"
            :disabled="undoDisable"
            >撤销</el-button
          >
          <el-button
            size="mini"
            class="iconfont icon-pc-next"
            @click="redoCommand"
            :disabled="redoDisable"
            >重做</el-button
          >
        </el-col>
        <el-col :span="6" class="text-right">
          <el-button type="primary" size="mini" @click="saveNodeData" :loading="saveLoading"
            >保存</el-button
          >
        </el-col>
      </el-row>
    </div>
    <el-dialog
      v-dialogDrag
      title="阵列"
      :visible.sync="cloneNodeVisible"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :before-close="closeCloneDialog"
      width="28%"
    >
      <div class="text-white">
        <el-row :gutter="10" type="flex" align="middle">
          <el-col :span="3">
            <el-radio v-model="isIncrement" @change="isTotal = !isIncrement" :label="true"
              >增量</el-radio
            >
          </el-col>
          <el-col :span="1"><span>X</span></el-col>
          <el-col :span="5"
            ><el-input-number
              :disabled="!isIncrement"
              v-model="incrementForm.offset[0]"
              size="mini"
              class="w-full"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="1"><span>Y</span></el-col>
          <el-col :span="5"
            ><el-input-number
              :disabled="!isIncrement"
              v-model="incrementForm.offset[1]"
              size="mini"
              class="w-full"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="1"><span>Z</span></el-col>
          <el-col :span="5"
            ><el-input-number
              :disabled="!isIncrement"
              v-model="incrementForm.offset[2]"
              size="mini"
              class="w-full"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="1"><span>m</span></el-col>
        </el-row>
        <div class="pl-18px mt-20px border-b pb-10px flex items-center">
          <span class="mr-10px">阵列数量</span>
          <el-input-number
            :disabled="!isIncrement"
            v-model="incrementForm.count"
            class="w-96px"
            :min="1"
            size="mini"
            controls-position="right"
          ></el-input-number>
        </div>
        <el-row :gutter="10" type="flex" align="middle" class="mt-10px">
          <el-col :span="3">
            <el-radio v-model="isTotal" @change="isIncrement = !isTotal" :label="true"
              >总计</el-radio
            >
          </el-col>
          <el-col :span="1"><span>X</span></el-col>
          <el-col :span="5"
            ><el-input-number
              :disabled="!isTotal"
              v-model="totalForm.offset[0]"
              size="mini"
              class="w-full"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="1"><span>Y</span></el-col>
          <el-col :span="5"
            ><el-input-number
              :disabled="!isTotal"
              v-model="totalForm.offset[1]"
              size="mini"
              class="w-full"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="1"><span>Z</span></el-col>
          <el-col :span="5"
            ><el-input-number
              :disabled="!isTotal"
              v-model="totalForm.offset[2]"
              size="mini"
              class="w-full"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="1"><span>m</span></el-col>
        </el-row>
        <div class="ml-18px mt-20px flex items-center">
          <span class="mr-10px">阵列总数</span>
          <el-input-number
            :disabled="!isTotal"
            v-model="totalForm.count"
            class="w-96px"
            :min="1"
            size="mini"
            controls-position="right"
          ></el-input-number>
        </div>
      </div>
      <div slot="footer" class="flex justify-between">
        <div>
          <el-button @click="resetForm" size="small">重 置</el-button>
          <el-button @click="closeCloneDialog" size="small">取 消</el-button>
        </div>
        <el-button type="primary" @click="confimCloneNode" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>
<script>
// import DocumentManagementService from '@/services/documentManagement'
import dayjs from 'dayjs'
import { CommandManage } from '../../assets/js/model/commandManage'
import {
  saveSceneToJson,
  isJSONObj,
  EnumObjectTypes,
  generateGUID,
} from '../../assets/js/scene/scene'

export default {
  name: 'NodeEditTool',
  props: ['player', 'customProps', 'location'],
  data() {
    return {
      currentTagCode: '',
      localTranslation: [0, 0, 0], // 位置变换
      localRotation: [0, 0, 0], // 旋转变换
      localScaling: [1, 1, 1], // 缩放变换
      commandManage: null,
      changeTimerOut: null,
      editType: 0, // 编辑方式
      saveLoading: false,
      currentNodePtr: null,
      isSaveNodeList: [],
      cloneNodeVisible: false,
      isIncrement: true,
      incrementForm: {
        offset: [0, 0, 0],
        count: 0,
      },
      isTotal: false,
      totalForm: {
        offset: [0, 0, 0],
        count: 0,
      },
      cloneNodeInfo: {},
    }
  },
  watch: {
    'customProps.currentNodeData': {
      async handler(val, oldVal) {
        if (oldVal?.node) {
          await this.player.Native?.Node.removeNodeFromAxisEdit(oldVal.node)
        }
        if (val.node && val.node !== oldVal?.node) {
          const index = this.isSaveNodeList.indexOf(oldVal?.node)
          if (index === -1 && this.commandManage && oldVal?.node) {
            await this.resetCommand()
          }
          if (index !== -1) {
            this.isSaveNodeList.splice(index, 1)
          }
          this.currentTagCode = val.name
          this.currentNodePtr = val.node
          this.initCommand(val.node)
          await this.player.Native?.Node.addNodeToAxisEdit(this.currentNodePtr)
        }
        if (!val.node) {
          if (oldVal?.node) {
            const index = this.isSaveNodeList.indexOf(oldVal?.node)
            if (index === -1 && this.commandManage && oldVal?.node) {
              await this.resetCommand()
            }
          }
          this.currentNodePtr = 0
          this.localTranslation = [0, 0, 0]
          this.localRotation = [0, 0, 0]
          this.localScaling = [1, 1, 1]
          this.currentTagCode = ''
          this.editType = 0
        }
      },
      deep: true,
    },
  },
  async created() {
    this.player.Native.Node.EventAxisEditFinish.connect(this.watchEditMsg)
    if (
      this.customProps.currentNodeData?.code &&
      isJSONObj(this.customProps.currentNodeData?.code)
    ) {
      this.currentNodePtr = this.customProps.currentNodeData.node
      this.currentTagCode = this.customProps.currentNodeData.name
      await this.player.Native?.Node.addNodeToAxisEdit(this.currentNodePtr)
      this.initCommand(this.currentNodePtr)
    }
  },
  beforeDestroy() {
    this.closeComponent()
    this.player.Native.Node.EventAxisEditFinish.disconnect(this.watchEditMsg)
  },
  computed: {
    undoDisable() {
      return _.isNil(this.commandManage) || this.commandManage.executeCount <= 0
    },
    redoDisable() {
      return _.isNil(this.commandManage) || this.commandManage.redoList.length <= 0
    },
    resetDisable() {
      return (
        _.isNil(this.commandManage) ||
        this.commandManage.isReset ||
        this.commandManage.undoList.length <= 0
      )
    },
  },
  methods: {
    async toCloneNode() {
      if (!this.currentNodePtr) {
        this.$message.warning('请选择模型节点')
        return
      }
      this.cloneNodeInfo = await this.player.Native.Node.getProperty(this.currentNodePtr, [
        'code',
        'name',
        'parent',
      ])
      if (
        this.cloneNodeInfo &&
        this.cloneNodeInfo.code &&
        isJSONObj(this.cloneNodeInfo.code) &&
        EnumObjectTypes.includes(JSON.parse(this.cloneNodeInfo.code).type)
      ) {
        this.cloneNodeVisible = true
      } else {
        this.$message.warning('该节点无法进行克隆操作')
      }
    },
    // 关闭阵列
    closeCloneDialog() {
      this.resetForm()
      this.cloneNodeVisible = false
    },
    // 重置
    resetForm() {
      this.isIncrement = true
      this.isTotal = false
      this.cloneNodeInfo = this.$options.data().cloneNodeInfo
      this.incrementForm = this.$options.data().incrementForm
      this.totalForm = this.$options.data().totalForm
    },
    // 克隆节点
    async confimCloneNode() {
      const position = (
        await this.player.Native.Node.getProperty(this.currentNodePtr, ['localTrans'])
      ).localTrans
      const jsonData = JSON.parse(this.cloneNodeInfo.code)
      if (this.isIncrement && this.incrementForm.count) {
        await this.referencesClone(position, jsonData, this.incrementForm, 1)
      }
      if (this.isTotal && this.totalForm.count) {
        await this.referencesClone(position, jsonData, this.totalForm, this.totalForm.count)
      }
      this.$message.success('克隆成功')
      // this.player.Native.ModelTree.setSelectItem(0)
      this.closeCloneDialog()
    },
    // 增量克隆
    async referencesClone(position, jsonData, formData, count = 1) {
      let sourcePosX = position[0]
      let sourcePosY = position[1]
      let sourcePosZ = position[2]
      const cloneNodes = await this.player.Native.Node.clone(
        this.cloneNodeInfo.node,
        formData.count
      )
      await this.player.Native.Node.addToFactory(cloneNodes)
      const params = []
      const addParams = []
      for (let i = 0; i < cloneNodes.length; i += 1) {
        jsonData.id = generateGUID()
        const p = {
          node: cloneNodes[i],
          code: JSON.stringify(jsonData),
          name: `${this.cloneNodeInfo.name}${dayjs().valueOf().toString().slice(5, 13) + i}`,
          localTrans: [
            (sourcePosX += formData.offset[0] / count),
            (sourcePosY += formData.offset[1] / count),
            (sourcePosZ += formData.offset[2] / count),
          ],
          parent: this.cloneNodeInfo.parent,
        }
        addParams.push(p)
        params.push({
          node: cloneNodes[i],
          props: p,
        })
      }
      await this.player.Native.Node.setProperty(params)
      this.$emit('componentEmit', 'addModel', addParams)
    },
    // 初始化操作
    async initCommand(node) {
      const info = await this.player.Native.Node.getProperty(node, [
        'localTrans',
        'localRot',
        'localScale',
      ])
      this.localTranslation = info.localTrans
      const quat = info.localRot
      // PlayerUtil公用方法
      this.localRotation = _.map(EulerAngle.fromQuat(quat), (item) => {
        return _.round(item, 2)
      })
      this.localScaling = info.localScale
      this.commandManage = new CommandManage({
        localTranslation: _.cloneDeep(this.localTranslation),
        localRotation: quat,
        localScaling: _.cloneDeep(this.localScaling),
      })
    },
    // 保存节点状态
    async saveNodeData() {
      this.isSaveNodeList.push(this.currentNodePtr)
      this.initCommand(this.currentNodePtr)
    },
    // 改变位置
    async changeLocalTranslation() {
      if (this.currentNodePtr) {
        const index = this.isSaveNodeList.indexOf(this.currentNodePtr)
        if (index !== -1) {
          this.isSaveNodeList.splice(index, 1)
        }
        if (this.changeTimerOut) {
          clearTimeout(this.changeTimerOut)
        }
        this.changeTimerOut = setTimeout(async () => {
          // PlayerUtil公用方法
          const toQuat = EulerAngle.toQuat(this.localRotation)
          await this.player.Native.Node.setProperty(this.currentNodePtr, {
            localTrans: this.localTranslation,
          })
          this.commandManage.executeCommand({
            localTranslation: _.cloneDeep(this.localTranslation),
            localRotation: toQuat,
            localScaling: _.cloneDeep(this.localScaling),
          })
        }, 500)
      }
    },
    // 改变旋转
    async changeLocalRotation() {
      if (this.currentNodePtr) {
        const index = this.isSaveNodeList.indexOf(this.currentNodePtr)
        if (index !== -1) {
          this.isSaveNodeList.splice(index, 1)
        }
        if (this.changeTimerOut) {
          clearTimeout(this.changeTimerOut)
        }
        this.changeTimerOut = setTimeout(async () => {
          // PlayerUtil公用方法
          const toQuat = EulerAngle.toQuat(this.localRotation)
          await this.player.Native.Node.setProperty(this.currentNodePtr, { localRot: toQuat })
          this.commandManage.executeCommand({
            localTranslation: _.cloneDeep(this.localTranslation),
            localRotation: toQuat,
            localScaling: _.cloneDeep(this.localScaling),
          })
        }, 500)
      }
    },
    // 改变缩放
    changeLocalScaling() {
      if (this.currentNodePtr) {
        const index = this.isSaveNodeList.indexOf(this.currentNodePtr)
        if (index !== -1) {
          this.isSaveNodeList.splice(index, 1)
        }
        if (this.changeTimerOut) {
          clearTimeout(this.changeTimerOut)
        }
        this.changeTimerOut = setTimeout(async () => {
          // PlayerUtil公用方法
          const toQuat = EulerAngle.toQuat(this.localRotation)
          await this.player.Native.Node.setProperty(this.currentNodePtr, {
            localScale: this.localScaling,
          })
          this.commandManage.executeCommand({
            localTranslation: _.cloneDeep(this.localTranslation),
            localRotation: toQuat,
            localScaling: _.cloneDeep(this.localScaling),
          })
        }, 500)
      }
    },
    // 关闭弹框
    async closeComponent() {
      this.currentNodePtr = 0
      this.currentTagCode = 0
      this.editType = 0
      this.resetCommand()
      await this.player.Native?.Node.removeNodeFromAxisEdit(this.currentNodePtr)
      this.$emit('closeComponent', 'NodeEditTool')
    },
    // 设置模型编辑方式
    async setEditType(type) {
      if (!this.currentNodePtr) {
        this.$message.warning('请选择编辑节点')
        return
      }
      if (this.editType === type) {
        this.editType = 0
        // await this.player.Native?.Node.removeNodeFromAxisEdit(this.currentNodePtr)
        await this.player.Native?.Node.setAxisEditType(0)
        return
      }
      this.editType = type
      const info = await this.player.Native.Node.getProperty(this.currentNodePtr, [
        'localTrans',
        'localRot',
        'localScale',
      ])
      this.localTranslation = info.localTrans
      const quat = info.localRot
      this.localRotation = _.map(EulerAngle.fromQuat(quat), (item) => {
        return _.round(item, 2)
      })
      this.localScaling = info.localScale
      await this.player.Native?.Node.setAxisEditType(type)
    },
    // 撤销
    async undoCommand() {
      const undoData = this.commandManage.undoCommand()
      if (undoData) {
        await this.setNodeChange(undoData.currentData)
      }
    },
    // 重做
    async redoCommand() {
      const redoData = this.commandManage.redoCommand()
      if (redoData) {
        await this.setNodeChange(redoData.currentData)
      }
    },
    // 重置
    async resetCommand() {
      if (!this.currentNodePtr) {
        return
      }
      const initData = this.commandManage.resetCommand()
      if (initData) {
        await this.setNodeChange(initData)
      }
      await this.initCommand(this.currentNodePtr)
    },
    // 设置模型位移、缩放、旋转
    async setNodeChange(data) {
      this.localTranslation = data.localTranslation
      const quat = data.localRotation
      // PlayerUtil公用方法
      this.localRotation = _.map(EulerAngle.fromQuat(quat), (item) => {
        return _.round(item, 2)
      })
      this.localScaling = data.localScaling
      await this.player.Native.Node.setProperty(this.currentNodePtr, {
        localTrans: this.localTranslation,
        localRot: quat,
        localScale: this.localScaling,
      })
    },
    // 监听编辑结束
    async watchEditMsg(res) {
      const index = this.isSaveNodeList.indexOf(this.currentNodePtr)
      if (index !== -1) {
        this.isSaveNodeList.splice(index, 1)
      }
      const info = await this.player.Native.Node.getProperty(this.currentNodePtr, [
        'localTrans',
        'localRot',
        'localScale',
      ])
      this.localTranslation = info.localTrans
      const quat = info.localRot
      this.localRotation = _.map(EulerAngle.fromQuat(quat), (item) => {
        return _.round(item, 2)
      })
      this.localScaling = info.localScale
      this.commandManage.executeCommand({
        localTranslation: _.cloneDeep(this.localTranslation),
        localRotation: quat,
        localScaling: _.cloneDeep(this.localScaling),
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/style/index';

.model-edit-tool {
  background-color: rgba(0, 18, 55, 0.3) !important;
  border: none !important;
}

::v-deep .el-card {
  &__header {
    background-color: transparent !important;
  }

  &__body {
    padding: 0 !important;
    height: calc(100% - 60px);
    color: #fff !important;
    background-color: rgba(24, 41, 72, 0.5) !important;
    border-radius: 2px;
  }
}

.card-footer {
  border: none;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}
</style>
